import { RefObject } from "react";
import {
	IShopPurchaseOfferMultiItem,
	IShopSection
} from "contexts/WebStoreProvider/types";
import getSectionIcon from "utils/svgIcons";
import { FeaturedOfferCardV2 } from "../FeaturedOfferCardV2";
import Section from "components/Section";
import { sortByPriority } from "utils/sort";
import { SxProps } from "@mui/material";
import { SectionSource } from "interfaces/web-store/section-source";

const FeaturedOfferSectionV2 = ({
	data,
	sectionRef,
	sectionOffers,
	headerSx,
	from
}: {
	className?: string;
	data: IShopSection;
	sectionRef: RefObject<HTMLElement>;
	sectionOffers: IShopPurchaseOfferMultiItem[];
	headerSx?: SxProps;
	from?: SectionSource;
}): JSX.Element => {
	const offers: JSX.Element[] = sortByPriority(sectionOffers).map((offer) => {
		return (
			<FeaturedOfferCardV2
				data={offer as IShopPurchaseOfferMultiItem}
				key={offer.rewardId}
				sectionName={data.name}
				from={from}
			/>
		);
	});

	const sectionProps = {
		offers,
		sectionRef,
		headerText: data.title,
		iconUrl: getSectionIcon(data.name)?.url,
		icon: getSectionIcon(data.name)?.svg,
		display: "carouselv2",
		sectionPage: "featured",
		headerSx,
		from
	};

	return <Section {...sectionProps} />;
};

FeaturedOfferCardV2.displayName = "FeaturedOfferSection";

export { FeaturedOfferSectionV2 };
